import { UserTypesEnum } from '~/constants/enums';
import { SvgIconType } from '@aqarmap/aqarmap-ui';
import { useFullRoutes } from '~/hooks';

export type LinkType = {
  url: string;
  title: string;
  icon: SvgIconType;
  subUrl?: string;
};

const useSidebarLinks = (userType: UserTypesEnum) => {
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const accountInfo: LinkType = {
    url: MY_ACCOUNT_URL.DETAILS,
    title: 'accountDetails',
    icon: 'user',
    subUrl: MY_ACCOUNT_URL.UPDATE_NAME,
  };
  const privacy: LinkType = {
    url: MY_ACCOUNT_URL.SETTINGS_AND_PRIVACY,
    title: 'privacy',
    icon: 'settings',
  };
  const companyInfo: LinkType = {
    url: MY_ACCOUNT_URL.COMPANY_INFO,
    title: 'companyInfo',
    icon: 'company',
  };
  const personalInfo: LinkType = {
    url: MY_ACCOUNT_URL.PERSONAL_INFO,
    title: 'personalInfo',
    icon: 'user-info',
  };
  const manageContact: LinkType = {
    url: MY_ACCOUNT_URL.MANAGE_CONTACTS,
    title: 'manageContact',
    icon: 'user-edit',
  };
  const userCards: LinkType = {
    url: MY_ACCOUNT_URL.USER_CARDS.ROOT,
    title: 'savedCards',
    icon: 'visa',
  };
  const wallet: LinkType = {
    url: MY_ACCOUNT_URL.WALLET.ROOT,
    title: 'wallet',
    icon: 'wallet',
  };
  const userSubscription: LinkType = {
    url: MY_ACCOUNT_URL.USER_SUBSCRIPTION,
    title: 'subscriptionPlan',
    icon: 'premium',
  };

  let links: LinkType[] = [
    accountInfo,
    privacy,
    userCards,
    wallet,
    userSubscription,
  ];

  switch (userType) {
    case UserTypesEnum.COMPOUND_DEVELOPER:
      links.push(companyInfo, manageContact);
      break;

    case UserTypesEnum.SMALL_DEVELOPER:
      links.push(companyInfo, manageContact);
      break;
    case UserTypesEnum.ALL_TYPES:
      links.push(companyInfo, personalInfo, manageContact);
      break;

    case UserTypesEnum.BROKER:
      links.push(companyInfo, manageContact);
      break;

    case UserTypesEnum.INDIVIDUAL:
      links.push(manageContact);
      break;
    case UserTypesEnum.BUYER:
      links.push(personalInfo);
      break;

    default:
      break;
  }
  return links;
};

export default useSidebarLinks;
